import React from 'react';
import Radium from 'radium';
import Animate from 'rc-animate';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { actions as passwordActions } from './redux/modules/password';
import ErrorMessage from './components/messages/ErrorMessage';
import Card from './components/Card';
import StyleDecorator from './components/StyleDecorator';
import UsernameInput from './components/inputs/UsernameInput';
import Button from './components/buttons/Button';
import RootPageLink from './components/links/RootPageBackLink';
import LandingPageLink from './components/links/LandingPageLink';
import translate from './locale/translate';
import SipgateFormHeaderLogo from './components/images/SipgateFormHeaderLogo';
import { paths } from './routes/index';
import VARIANTS from './utils/variants';

const mapStateToProps = (state, ownProps) => ({
	fetching: state.password.fetching,
	passwordResetRequested: state.password.passwordResetRequested,
	passwordResetRequestFailed: state.password.passwordResetRequestFailed,
	variant: ownProps.location.query.variant,
});

const style = {
	form: {
		width: '100%',
	},
	forgotPasswordLink: {
		transform: 'scale(0.75)',
		display: 'inline-block',
		transformOrigin: 'right',
	},
	forgotPasswordContainer: {
		textAlign: 'right',
	},
	button: {
		marginTop: '35px',
	},
};

export class RequestPasswordResetApp extends React.Component {
	static propTypes = {
		resetToInitialState: React.PropTypes.func.isRequired,
		requestPasswordReset: React.PropTypes.func.isRequired,
		passwordResetRequested: React.PropTypes.bool.isRequired,
		passwordResetRequestFailed: React.PropTypes.bool.isRequired,
		fetching: React.PropTypes.bool.isRequired,
		variant: React.PropTypes.string,
	};

	handleSubmit = (e) => {
		e.preventDefault();

		const { username } = e.target.elements;

		const usernameInput = username.value.trim();

		if (!usernameInput) {
			username.focus();
			return;
		}

		this.props.requestPasswordReset(usernameInput);
	};

	componentWillReceiveProps(nextProps) {
		if (nextProps.passwordResetRequested && !this.props.passwordResetRequested) {
			this.props.resetToInitialState();
			browserHistory.push(paths.RESET_PASSWORD_SUCCESS);
		}
	}

	render() {
		const message = this.props.passwordResetRequestFailed
			? (
				<Animate
					transitionName={'alert'}
					transitionAppear
				>
					<ErrorMessage text={translate('PASSWORD_RESET_REQUEST_FAILED_MESSAGE')} />
				</Animate>
			)
			: null;

		const footer = (
			<div>
				<Button
					type={'submit'}
					style={{ ...style.button }}
					disabled={this.props.fetching}
				>
					{translate('BUTTON_REQUEST_NEW_PASSWORD')}
				</Button>
				{
					this.props.variant === VARIANTS.TEAM
						? <RootPageLink />
						: <LandingPageLink />
				}
			</div>
		);

		return (
			<form
				className={'flex-container'}
				onSubmit={this.handleSubmit}
				style={style.form}
				noValidate
			>
				<Card
					header={<SipgateFormHeaderLogo />}
					footer={footer}
					preBody={message}
				>
					<UsernameInput
						name={'username'}
						placeholder={translate('FORM_LABEL_EMAIL')}
					/>
				</Card>
			</form>
		);
	}
}

export default connect(
	mapStateToProps,
	{ ...passwordActions }
)(StyleDecorator(Radium(RequestPasswordResetApp)));



// WEBPACK FOOTER //
// ./src/RequestPasswordResetApp.js